import {AppVersion} from '../../types/AppVersion';
import {AppFilterStrategy} from './AppFilterStrategy';

/**
 * Filter strategy for filtering apps by category.
 * Checks if the app's categories array includes the specified category.
 */
export class CategoryFilterStrategy extends AppFilterStrategy<string> {
  public matches(app: AppVersion, filterValue: string | undefined): boolean {
    if (!this.isActive(filterValue)) {
      return true;
    }

    // Some apps may not have categories defined
    if (!app.metadata.categories) {
      return false;
    }

    return app.metadata.categories.includes(filterValue!);
  }
}
